/**
 * Major Cities of Mexico
 *
 * Contains coordinates and metadata for the largest cities in Mexico.
 * Used for markers, clusters, and point-based visualizations.
 *
 * @module mexicoCities
 */

export const MEXICO_CITIES = [
  // Mega cities (5M+)
  { id: 'cdmx', name: 'Ciudad de México', state: 'CMX', lat: 19.4326, lng: -99.1332, population: 9209944, type: 'capital' },

  // Major metro areas (1M+)
  { id: 'gdl', name: 'Guadalajara', state: 'JAL', lat: 20.6597, lng: -103.3496, population: 5268642, type: 'major' },
  { id: 'mty', name: 'Monterrey', state: 'NLE', lat: 25.6866, lng: -100.3161, population: 5341171, type: 'major' },
  { id: 'pue', name: 'Puebla', state: 'PUE', lat: 19.0414, lng: -98.2063, population: 3199530, type: 'major' },
  { id: 'tij', name: 'Tijuana', state: 'BCN', lat: 32.5149, lng: -117.0382, population: 2157853, type: 'major' },
  { id: 'leo', name: 'León', state: 'GUA', lat: 21.1221, lng: -101.6860, population: 1721215, type: 'major' },
  { id: 'jua', name: 'Ciudad Juárez', state: 'CHH', lat: 31.6904, lng: -106.4245, population: 1512450, type: 'major' },
  { id: 'tor', name: 'Torreón', state: 'COA', lat: 25.5428, lng: -103.4068, population: 1475315, type: 'major' },
  { id: 'qro', name: 'Querétaro', state: 'QUE', lat: 20.5888, lng: -100.3899, population: 1404306, type: 'major' },
  { id: 'slp', name: 'San Luis Potosí', state: 'SLP', lat: 22.1565, lng: -100.9855, population: 1243980, type: 'major' },

  // Large cities (500K-1M)
  { id: 'mer', name: 'Mérida', state: 'YUC', lat: 20.9674, lng: -89.5926, population: 1143000, type: 'large' },
  { id: 'ags', name: 'Aguascalientes', state: 'AGU', lat: 21.8853, lng: -102.2916, population: 1140916, type: 'large' },
  { id: 'cun', name: 'Cancún', state: 'ROO', lat: 21.1619, lng: -86.8515, population: 888797, type: 'large' },
  { id: 'her', name: 'Hermosillo', state: 'SON', lat: 29.0729, lng: -110.9559, population: 884273, type: 'large' },
  { id: 'sal', name: 'Saltillo', state: 'COA', lat: 25.4232, lng: -100.9953, population: 823128, type: 'large' },
  { id: 'mex', name: 'Mexicali', state: 'BCN', lat: 32.6245, lng: -115.4523, population: 1049792, type: 'large' },
  { id: 'cul', name: 'Culiacán', state: 'SIN', lat: 24.8049, lng: -107.3940, population: 905265, type: 'large' },
  { id: 'mor', name: 'Morelia', state: 'MIC', lat: 19.7060, lng: -101.1950, population: 849053, type: 'large' },
  { id: 'chi', name: 'Chihuahua', state: 'CHH', lat: 28.6353, lng: -106.0889, population: 925762, type: 'large' },
  { id: 'ver', name: 'Veracruz', state: 'VER', lat: 19.1738, lng: -96.1342, population: 811671, type: 'large' },

  // Medium cities (200K-500K)
  { id: 'vil', name: 'Villahermosa', state: 'TAB', lat: 17.9892, lng: -92.9475, population: 684156, type: 'medium' },
  { id: 'tux', name: 'Tuxtla Gutiérrez', state: 'CHP', lat: 16.7516, lng: -93.1152, population: 604147, type: 'medium' },
  { id: 'rey', name: 'Reynosa', state: 'TAM', lat: 26.0508, lng: -98.2979, population: 700793, type: 'medium' },
  { id: 'aca', name: 'Acapulco', state: 'GRO', lat: 16.8531, lng: -99.8237, population: 779566, type: 'medium' },
  { id: 'dur', name: 'Durango', state: 'DUR', lat: 24.0277, lng: -104.6532, population: 654876, type: 'medium' },
  { id: 'tol', name: 'Toluca', state: 'MEX', lat: 19.2826, lng: -99.6557, population: 2353924, type: 'medium' },
  { id: 'mat', name: 'Matamoros', state: 'TAM', lat: 25.8690, lng: -97.5027, population: 520367, type: 'medium' },
  { id: 'cue', name: 'Cuernavaca', state: 'MOR', lat: 18.9242, lng: -99.2216, population: 366321, type: 'medium' },
  { id: 'nvo', name: 'Nuevo Laredo', state: 'TAM', lat: 27.4767, lng: -99.5165, population: 425058, type: 'medium' },
  { id: 'paz', name: 'La Paz', state: 'BCS', lat: 24.1426, lng: -110.3128, population: 305455, type: 'medium' },
  { id: 'cam', name: 'Campeche', state: 'CAM', lat: 19.8301, lng: -90.5349, population: 294077, type: 'medium' },
  { id: 'oax', name: 'Oaxaca', state: 'OAX', lat: 17.0732, lng: -96.7266, population: 270955, type: 'medium' },
  { id: 'tep', name: 'Tepic', state: 'NAY', lat: 21.5085, lng: -104.8946, population: 429351, type: 'medium' },
  { id: 'zac', name: 'Zacatecas', state: 'ZAC', lat: 22.7709, lng: -102.5833, population: 153461, type: 'medium' },
  { id: 'col', name: 'Colima', state: 'COL', lat: 19.2452, lng: -103.7241, population: 150673, type: 'medium' },
  { id: 'pac', name: 'Pachuca', state: 'HID', lat: 20.1011, lng: -98.7591, population: 277375, type: 'medium' },
  { id: 'tla', name: 'Tlaxcala', state: 'TLA', lat: 19.3139, lng: -98.2404, population: 103435, type: 'medium' },
  { id: 'che', name: 'Chetumal', state: 'ROO', lat: 18.5001, lng: -88.2961, population: 169028, type: 'medium' },
  { id: 'gmo', name: 'Guanajuato', state: 'GUA', lat: 21.0190, lng: -101.2574, population: 184239, type: 'medium' },
  { id: 'pue', name: 'Puerto Vallarta', state: 'JAL', lat: 20.6534, lng: -105.2253, population: 291839, type: 'medium' },

  // Tourist destinations
  { id: 'cab', name: 'Los Cabos', state: 'BCS', lat: 22.8905, lng: -109.9167, population: 351111, type: 'tourist' },
  { id: 'pdc', name: 'Playa del Carmen', state: 'ROO', lat: 20.6296, lng: -87.0739, population: 304942, type: 'tourist' },
  { id: 'sma', name: 'San Miguel de Allende', state: 'GUA', lat: 20.9144, lng: -100.7452, population: 175894, type: 'tourist' },
  { id: 'ixt', name: 'Ixtapa-Zihuatanejo', state: 'GRO', lat: 17.6389, lng: -101.5519, population: 124824, type: 'tourist' },
  { id: 'maz', name: 'Mazatlán', state: 'SIN', lat: 23.2494, lng: -106.4111, population: 502547, type: 'tourist' },
  { id: 'coz', name: 'Cozumel', state: 'ROO', lat: 20.4230, lng: -86.9223, population: 86415, type: 'tourist' },

  // Industrial centers
  { id: 'cel', name: 'Celaya', state: 'GUA', lat: 20.5236, lng: -100.8156, population: 494304, type: 'industrial' },
  { id: 'ira', name: 'Irapuato', state: 'GUA', lat: 20.6767, lng: -101.3560, population: 574344, type: 'industrial' },
  { id: 'tam', name: 'Tampico', state: 'TAM', lat: 22.2331, lng: -97.8611, population: 314418, type: 'industrial' },
  { id: 'mon', name: 'Monclova', state: 'COA', lat: 26.9007, lng: -101.4214, population: 231107, type: 'industrial' },
  { id: 'nog', name: 'Nogales', state: 'SON', lat: 31.3082, lng: -110.9426, population: 264782, type: 'industrial' },
  { id: 'ens', name: 'Ensenada', state: 'BCN', lat: 31.8667, lng: -116.5964, population: 486639, type: 'industrial' }
];

/**
 * Get cities by state
 * @param {string} stateId - State ID (e.g., 'JAL', 'NLE')
 * @returns {Array} Cities in the specified state
 */
export const getCitiesByState = (stateId) => {
  return MEXICO_CITIES.filter(city => city.state === stateId);
};

/**
 * Get cities by type
 * @param {string} type - City type (capital, major, large, medium, tourist, industrial)
 * @returns {Array} Cities of the specified type
 */
export const getCitiesByType = (type) => {
  return MEXICO_CITIES.filter(city => city.type === type);
};

/**
 * Get top N cities by population
 * @param {number} n - Number of cities to return
 * @returns {Array} Top N cities by population
 */
export const getTopCities = (n = 10) => {
  return [...MEXICO_CITIES]
    .sort((a, b) => b.population - a.population)
    .slice(0, n);
};

/**
 * City type colors for visualization
 */
export const CITY_TYPE_COLORS = {
  capital: '#dc2626',    // Red - Capital
  major: '#ea580c',      // Orange - Major metros
  large: '#ca8a04',      // Yellow - Large cities
  medium: '#16a34a',     // Green - Medium cities
  tourist: '#0ea5e9',    // Sky - Tourist destinations
  industrial: '#7c3aed'  // Violet - Industrial centers
};

/**
 * City type labels
 */
export const CITY_TYPE_LABELS = {
  capital: 'Capital Nacional',
  major: 'Área Metropolitana',
  large: 'Ciudad Grande',
  medium: 'Ciudad Media',
  tourist: 'Destino Turístico',
  industrial: 'Centro Industrial'
};
